import { restClient } from '@/Core/Services/RestClientService'
import { AppConfig } from '@/Ship/Configs/AppConfig'

/**
 * GET AppConfig.restUserMe — load the currently authenticated user's profile.
 * Used by `/profile` page (UserProfilePage) on mount and after edit-drawer close.
 */
export const LoadCurrentUserTask = async (): Promise<any> => {
    return restClient.get(AppConfig.restUserMe)
}
